/** Un chapitre (SCO) d'un module, tel que le lecteur le propose (#160). */
export type ScoOption = { identifier: string, title: string, href: string }

/**
 * Le chapitre à jouer : celui que l'apprenant vient de choisir, sinon le
 * dernier ouvert (la reprise), sinon le premier.
 */
export function activeSco(scos: ScoOption[], chosen: string | null, lastOpened: string | null | undefined): ScoOption | undefined {
  return scos.find(sco => sco.identifier === chosen)
    ?? scos.find(sco => sco.identifier === lastOpened)
    ?? scos[0]
}

/** Le prochain chapitre à faire après celui-ci, en reprenant au début si besoin ; aucun si tout est fait. */
export function nextSco(scos: ScoOption[], completed: ReadonlySet<string>, current: string): ScoOption | undefined {
  const from = scos.findIndex(sco => sco.identifier === current)
  const ordered = [...scos.slice(from + 1), ...scos.slice(0, Math.max(from, 0))]
  return ordered.find(sco => !completed.has(sco.identifier))
}
